// AUTO-WA-39 WhatsApp navigation, in the same shape as the main app's
// AUTO-319 workspaceNav.js. Old URLs keep working through redirects in AppRoutes.

const starts = (...prefixes) => (pathname) => prefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

// `setup: true` items need a connected WhatsApp number.
export const NAV_GROUPS = [
  {
    id: 'daily',
    items: [
      { id: 'home', label: 'Home', to: '/dashboard', icon: 'home', setup: true, match: starts('/dashboard') },
      { id: 'chats', label: 'Chats', to: '/conversation', icon: 'chats', setup: true, match: starts('/conversation') },
    ],
  },
  {
    id: 'reach',
    label: 'Reach',
    items: [
      { id: 'broadcasts', label: 'Broadcasts', to: '/broadcast', icon: 'broadcasts', setup: true, match: starts('/broadcast', '/broadcasts') },
      { id: 'contacts', label: 'Contacts', to: '/contacts', icon: 'contacts', setup: true, match: starts('/contacts') },
      { id: 'templates', label: 'Templates', to: '/templates', icon: 'templates', setup: true, match: starts('/templates') },
      { id: 'tags', label: 'Tags', to: '/tags', icon: 'tags', setup: true, match: starts('/tags') },
    ],
  },
  {
    id: 'automate',
    label: 'Automate',
    items: [
      { id: 'bots', label: 'Bots', to: '/bots', icon: 'bots', setup: true, match: starts('/bots', '/flows', '/chatbots') },
    ],
  },
  {
    id: 'account',
    label: 'Account',
    items: [
      { id: 'meta-billing', label: 'Meta Billing', to: '/meta-billing', icon: 'billing', setup: true, match: starts('/meta-billing', '/payment', '/settings/billing') },
    ],
  },
];

export const SETUP_ITEM = { id: 'setup', label: 'Connect WhatsApp', to: '/setup', icon: 'setup', match: starts('/setup') };

export const FOOTER_ITEMS = [
  { id: 'settings', label: 'Settings', to: '/settings/connection', icon: 'settings', match: (pathname) => !starts('/settings/billing')(pathname) && starts('/settings', '/api-keys')(pathname) },
  { id: 'help', label: 'Help', to: '/guide', icon: 'help', match: starts('/guide') },
];

export function visibleGroups(connected) {
  if (connected) return NAV_GROUPS;
  return [{ id: 'daily', items: [SETUP_ITEM] }];
}

export function activeItemId(pathname) {
  for (const group of NAV_GROUPS) {
    const found = group.items.find((item) => item.match(pathname));
    if (found) return found.id;
  }
  if (SETUP_ITEM.match(pathname)) return SETUP_ITEM.id;
  const footer = FOOTER_ITEMS.find((item) => item.match(pathname));
  return footer ? footer.id : null;
}
